export default "__VITE_ASSET__q3FQboxM__"